// 标题和描述常量
export const HEADER_CONSTANTS = {
  TITLE: 'DATAPULSE 数湃',
  SUBTITLE: 'MC Markets 运营数据分析平台',
  LOGO_ALT: 'MC Markets Logo',
  LOGO_SRC: '/mc-markets-logo.png'
};

// （已移除）状态指示器常量

// 通知消息常量
export const NOTIFICATION_MESSAGES = {
  AI_ANALYSIS_START: '🤖 正在调用 DeepSeek AI 服务分析运营数据...',
  AI_ANALYSIS_SUCCESS: '✅ AI 分析完成！基于真实的 DeepSeek API 结果',
  LOADING_KPI: '正在加载 {title} 的详细数据...'
};



// 背景渐变配置
export const BACKGROUND_GRADIENTS = {
  HEADER: `
    linear-gradient(135deg, #0f172a 0%, #1e293b 25%, #334155 50%, #475569 75%, #64748b 100%),
    radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(16, 185, 129, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(139, 92, 246, 0.08) 0%, transparent 50%)
  `,
  
  BEFORE_PSEUDO: `
    linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.03) 50%, transparent 100%),
    url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><defs><pattern id='grid' width='20' height='20' patternUnits='userSpaceOnUse'><path d='M 20 0 L 0 0 0 20' fill='none' stroke='rgba(255,255,255,0.04)' stroke-width='0.5'/></pattern></defs><rect width='100' height='100' fill='url(%23grid)'/></svg>")
  `,
  
  AFTER_PSEUDO: `
    radial-gradient(ellipse at top, rgba(255, 255, 255, 0.05) 0%, transparent 70%),
    linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.1) 100%)
  `
};

// 粒子动画配置
export const PARTICLE_CONFIG = {
  COUNT: 25,
  MIN_SIZE: 2,
  MAX_SIZE: 6,
  COLORS: {
    BLUE: 'rgba(59, 130, 246, ',
    GREEN: 'rgba(16, 185, 129, '
  },
  ANIMATION: {
    MIN_DURATION: 4,
    MAX_DURATION: 10,
    MAX_DELAY: 3
  }
};

// 粒子动画关键帧
export const PARTICLE_KEYFRAMES = {
  '0%': {
    transform: 'translateY(100vh) scale(0) rotate(0deg)',
    opacity: 0,
  },
  '10%': {
    opacity: 0.8,
    transform: 'translateY(90vh) scale(1) rotate(180deg)',
  },
  '50%': {
    opacity: 1,
    transform: 'translateY(50vh) scale(1.2) rotate(360deg)',
  },
  '90%': {
    opacity: 0.6,
    transform: 'translateY(10vh) scale(1) rotate(540deg)',
  },
  '100%': {
    transform: 'translateY(-50px) scale(0) rotate(720deg)',
    opacity: 0,
  },
};

// 样式常量
export const STYLE_CONSTANTS = {
  COLORS: {
    PRIMARY: '#00d4aa',
    WHITE: '#ffffff',
    LIGHT_GRAY: '#cccccc',
    BORDER: 'rgba(255, 255, 255, 0.1)'
  },
  FONTS: {
    MONO: '"Roboto Mono", "Courier New", monospace',
    SANS: '"Roboto", "Helvetica", sans-serif'
  },
  SPACING: {
    HEADER_PADDING: 8,
    STATUS_GAP: 3,
    STATUS_ITEM_GAP: 1
  }
};

// 错误消息常量
export const ERROR_MESSAGES = {
  AI_ANALYSIS_FAILED: '❌ AI分析错误:',
  USER_CANCELLED: '🛑 用户取消了AI分析操作',
  API_UNAVAILABLE: '⚠️ DeepSeek API 暂时不可用'
};

// 日志消息常量
export const LOG_MESSAGES = {
  PREPARING_ANALYSIS: '📊 准备分析 {count} 个 KPI 指标',
  ANALYSIS_COMPLETE: '✅ AI 分析完成！基于真实的 DeepSeek API 结果'
}; 